import { render, staticRenderFns } from "./TopBarPrimaryFilters.vue?vue&type=template&id=5f47e2ce&lang=pug&"
import script from "./TopBarPrimaryFilters.vue?vue&type=script&lang=js&"
export * from "./TopBarPrimaryFilters.vue?vue&type=script&lang=js&"
import style0 from "./TopBarPrimaryFilters.vue?vue&type=style&index=0&id=5f47e2ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports